import { useNavigate, useParams } from 'react-router'
import { useFetcher } from '../utils/fetcher'
import { useActions, useToast, useWebsite } from '../utils/hooks'
import { pDelay } from '@naturalcycles/js-lib/promise'
import { ROUTE } from '../cnst/router.cnst'
import { CmsWebsiteConfigBM } from '@bm-js/atlascloud-shared'

export const useCmsEditorApi = () => {
  const fetcher = useFetcher()
  const { triggerRebuild } = useActions()
  const { cmsWebsite } = useWebsite()
  const { id } = useParams()
  const toast = useToast()
  const navigate = useNavigate()

  const saveConfig = async (websiteConfig: CmsWebsiteConfigBM) => {
    const { err } = await fetcher({
      path: `cms-user/website/editor/${id}`,
      method: 'POST',
      body: { websiteConfig },
    })
    if (err) toast.error('Ändringarna kunde inte sparas')
    else toast.success('Ändringarna sparades')
  }

  const publishConfig = async (websiteConfig: CmsWebsiteConfigBM) => {
    const { err } = await fetcher({
      path: `cms-user/website/editor/publish/${id}`,
      method: 'POST',
      body: { websiteConfig },
    })
    if (err) toast.error('Publiceringen misslyckades')
    else toast.success('Publiceringen lyckades')
    await pDelay(500)

    if (cmsWebsite?.buildWebhook) {
      await triggerRebuild()
      toast.info('Sidan uppdateras, det kan ta ett par minuter')
    }

    await navigate(ROUTE.DASHBOARD)
  }

  return { saveConfig, publishConfig }
}
